import { useQuery } from '@apollo/client';

import { ClientDocument } from './graphql/client.gql';

export const useGetClient = (clientId?: string) => {
  const { data, ...rest } = useQuery(ClientDocument, {
    skip: !clientId,
    // Use non-null assertion because the GraphQL query requires a non null `clientId`
    // It's safe to do this because of the option `skip`
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    variables: { clientId: clientId! },
  });

  return { ...rest, client: data?.client };
};

export const refetchGetClient = (clientId: string) => {
  return {
    query: ClientDocument,
    variables: { clientId },
  };
};

export type Client = NonNullable<ReturnType<typeof useGetClient>['client']>;
